// extracted by mini-css-extract-plugin
export default {"wrapper":"upload-page_wrapper__9Jkkh","form":"upload-page_form__fWW-R","claimField":"upload-page_claimField__YDP-F"};